import { useTranslation } from 'react-i18next';
import { allocationService } from '../services/allocationService';
import type { ScopedExportRequest } from '../types/Filters';
import type { PercentageCheckFilters } from '../types/PercentageCheck';
import type { PercentageCheckColumn } from './usePercentageCheckColumns';
import { useSpreadsheetExport } from './useSpreadsheetExport';

export function useExportPercentageCheck(
  { page, perPage, ...filters }: PercentageCheckFilters,
  columns: readonly PercentageCheckColumn[],
) {
  const { t } = useTranslation('alocacao');
  return useSpreadsheetExport<ScopedExportRequest>(
    ({ scope, ...options }) =>
      allocationService.exportPercentageCheck(
        scope === 'page' ? { ...filters, page, perPage } : filters,
        { ...options, columns },
      ),
    t('consultas.conferenciaPercentual.nomeArquivo'),
  );
}
